module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "isCloseOnBgClick": false,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('div', [_c('h2', [_vm._v("Automatisk indberetning")]), _vm._v(" "), _c('p', {
    staticClass: "d-modal__subtitle"
  }, [_vm._v("\n          Opretter fraværsindberetninger ud fra fravær registreret i Vikardækning i den valgte periode.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content",
    class: {
      'd-modal__content--scroll': _vm.createdFravaer !== null
    }
  }, [(_vm.createdFravaer === null) ? [_c('div', {
    staticClass: "auto-period"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Periode:")]), _vm._v(" "), _c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "maximumDateRange": 365
    },
    on: {
      "startChanged": function($event) {
        return _vm.$emit('startChanged', $event)
      },
      "endChanged": function($event) {
        return _vm.$emit('endChanged', $event)
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n          Fravær der allerede er indberettet, springes over. Åbenstående fravær indberettes uden slutdato —\n          når fraværet senere afsluttes, oprettes en ny indberetning med den rigtige slutdato ved næste kørsel.\n          Indberetningerne lægges i udbakken og sendes automatisk til SD.\n        ")]), _vm._v(" "), (_vm.errorMessage) ? _c('p', {
    staticClass: "text-explainer text-explainer--danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()] : [(_vm.createdFravaer.length === 0) ? _c('p', {
    staticClass: "italic"
  }, [_vm._v("\n          Der blev ikke fundet nyt fravær i perioden. Alt fravær er enten allerede indberettet eller mangler\n          fraværskode/ansættelse.\n        ")]) : [_c('p', [_vm._v(_vm._s(_vm.createdFravaer.length) + " " + _vm._s(_vm.createdFravaer.length === 1 ? 'fraværsindberetning' : 'fraværsindberetninger') + " blev lagt i udbakken:")]), _vm._v(" "), _c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("NAVN")]), _vm._v(" "), _c('th', [_vm._v("FRAVÆRSTYPE")]), _vm._v(" "), _c('th', [_vm._v("FRA")]), _vm._v(" "), _c('th', [_vm._v("TIL")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.createdRows), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vAbsenceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vStartdato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vSlutdato))])])
  }), 0)])]]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__child"
  }, [(_vm.createdFravaer === null) ? [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting,
      'do-bttn--submit--disabled': !_vm.isValid
    },
    attrs: {
      "disabled": !_vm.isValid || _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            Hent og opret indberetninger\n          ")])] : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("Luk")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fc22468!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/Silkeborgdata/SdAutoFravaer.vue
// module id = 1998
// module chunks = 1